import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { PopupProvider } from "@/lib/PopupContext";
import ScrollToTop from "@/components/layout/ScrollToTop";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import LPHeader from "@/components/layout/LPHeader";
import LPFooter from "@/components/layout/LPFooter";
import Home from "@/pages/Home";
import AboutUs from "@/pages/AboutUs";
import ContactUs from "@/pages/ContactUs";
import LandingPage from "@/pages/LandingPage";
import ServicePage from "@/pages/ServicePage";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfService from "@/pages/TermsOfService";
import ThankYou from "@/pages/ThankYou";

function MainLayout({ children }) {
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
    </>
  );
}

function LPLayout({ children }) {
  return (
    <>
      <LPHeader />
      <main>{children}</main>
      <LPFooter />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <PopupProvider>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<MainLayout><Home /></MainLayout>} />
          <Route path="/about" element={<MainLayout><AboutUs /></MainLayout>} />
          <Route path="/contact" element={<MainLayout><ContactUs /></MainLayout>} />
          <Route path="/services/:slug" element={<MainLayout><ServicePage /></MainLayout>} />
          <Route path="/privacy-policy" element={<MainLayout><PrivacyPolicy /></MainLayout>} />
          <Route path="/terms-of-service" element={<MainLayout><TermsOfService /></MainLayout>} />
          <Route path="/lp" element={<LPLayout><LandingPage /></LPLayout>} />
          <Route path="/application/main" element={<ThankYou />} />
        </Routes>
      </PopupProvider>
    </BrowserRouter>
  );
}

export default App;
